// Base API URL definida via variáveis de ambiente
const basePath = process.env.API_URL || 'http://10.5.0.1:10020/'
let baseAPIGroup = 'public/'
let APIVersion = 'v1/'

export default {
  basePath: basePath,
  baseAPIGroup: baseAPIGroup,
  APIVersion: APIVersion,
  fullAPIPath: basePath + baseAPIGroup + APIVersion
}
